<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      serviceVisitArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Service Visits</mat-label>
        <input
          matInput
          (keyup)="filterServiceVisits($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.customer || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="serviceTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Type</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.serviceTypeName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="assignedName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Tech</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.assignedName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.createdDate | date : "shortDate" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="jobaddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.jobaddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.reason || "n/a" }}
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="serviceVisitId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Service ID #</th>
        <td mat-cell *matCellDef="let serviceVisit">
          {{ serviceVisit.serviceVisitId || "n/a" }}
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching results
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToServiceVisit(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
